/*
TODO: use the packages/stitch-hub-ds/src/plugins/ElementUI/index.js instead (but we'll need to do a search&replace to ALL element-ui components from <ElSomething />> to <ElementSomething />> )

In order to add a new component:
- look into ./node_modules/element-ui/lib for the right package and import it here
- add it to the "components" array
- add it to the export at the end of the file
*/
import ElButton from 'element-ui/lib/button'
import ElCard from 'element-ui/lib/card'
import ElClickOutside from 'element-ui/src/utils/clickoutside'
import ElCollapse from 'element-ui/lib/collapse'
import ElCollapseItem from 'element-ui/lib/collapse-item'
import ElDialog from 'element-ui/lib/dialog'
import ElDropdown from 'element-ui/lib/dropdown'
import ElDropdownItem from 'element-ui/lib/dropdown-item'
import ElDropdownMenu from 'element-ui/lib/dropdown-menu'
import ElForm from 'element-ui/lib/form'
import ElFormItem from 'element-ui/lib/form-item'
import ElInfiniteScroll from 'element-ui/lib/infinite-scroll'
import ElInput from 'element-ui/lib/input'
import ElLink from 'element-ui/lib/link'
import ElLoading from 'element-ui/lib/loading'
import ElMessage from 'element-ui/lib/message'
import ElMessageBox from 'element-ui/lib/message-box'
import ElNotification from 'element-ui/lib/notification'
import ElOption from 'element-ui/lib/option'
import ElPopover from 'element-ui/lib/popover'
import ElProgress from 'element-ui/lib/progress'
import ElSelect from 'element-ui/lib/select'
import ElSpinner from 'element-ui/lib/spinner'
import ElSwitch from 'element-ui/lib/switch'
import ElTabPane from 'element-ui/lib/tab-pane'
import ElTabs from 'element-ui/lib/tabs'
import ElTag from 'element-ui/lib/tag'

import locale from 'element-ui/lib/locale'
import localeEn from 'element-ui/lib/locale/lang/en'

const components = [
  ElButton,
  ElCard,
  ElCollapse,
  ElCollapseItem,
  ElDialog,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElForm,
  ElFormItem,
  ElInput,
  ElLink,
  ElOption,
  ElPopover,
  ElProgress,
  ElSelect,
  ElSpinner,
  ElSwitch,
  ElTabPane,
  ElTabs,
  ElTag
]

/**
 * @param {Vue} Vue
 */
const install = Vue => {
  locale.use(localeEn)

  components.forEach(component => {
    Vue.component(component.name, component)
  })

  Vue.directive('click-outside', ElClickOutside)
  Vue.use(ElInfiniteScroll)
  Vue.use(ElLoading)

  Vue.prototype.$msgbox = ElMessageBox
  Vue.prototype.$alert = ElMessageBox.alert
  Vue.prototype.$confirm = (message, title, options) =>
    ElMessageBox.confirm(message, title, {
      ...options,
      lockScroll: false
    })
  Vue.prototype.$prompt = ElMessageBox.prompt
  Vue.prototype.$notify = ElNotification
  Vue.prototype.$message = ElMessage
}

export {
  ElButton,
  ElCard,
  ElCollapse,
  ElCollapseItem,
  ElDialog,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElForm,
  ElFormItem,
  ElInput,
  ElLink,
  ElOption,
  ElPopover,
  ElProgress,
  ElSelect,
  ElSpinner,
  ElSwitch,
  ElTabPane,
  ElTabs,
  ElTag
}

export default { install }
